/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./PointsMap.vue?vue&type=template&id=3981cc0c&scoped=true"
import script from "./PointsMap.vue?vue&type=script&setup=true&lang=js"
export * from "./PointsMap.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PointsMap.vue?vue&type=style&index=0&id=3981cc0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3981cc0c",
  null
  
)

export default component.exports